module.exports = __webpack_public_path__ + "img/youshi.b03fc362.png";